import { AppSourceEnum } from 'pu-core-library';
import { UrlConfig } from '@shared/config/url.config';

export class DispositifConfig {

  private static dispositifFormations: string = UrlConfig.urlReferentiel + 'dispositif-formation';
  private static codesNsf: string = UrlConfig.urlReferentiel + 'codensfs/allnsf';

  public static get dispositifFormationsBySource(): string {
    return `${this.dispositifFormations}?pointAppel=${AppSourceEnum.POF}`;
  }

  public static get codesNsfList(): string {
    return DispositifConfig.codesNsf;
  }
}
